<template>
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="newspaper"
      d="M22.5,8.18V20.59a1.92,1.92,0,0,1-1.91,1.91,1.93,1.93,0,0,1-1.91-1.91V8.18Z"
    />
    <path
      class="newspaper"
      d="M20.59,22.5H3.41A1.9,1.9,0,0,1,1.5,20.59V1.5H18.68V20.59a1.93,1.93,0,0,0,1.91,1.91Z"
    />
    <rect class="newspaper" x="5.32" y="5.32" width="9.55" height="5.73" />
    <line class="newspaper" x1="4.36" y1="14.86" x2="15.82" y2="14.86" />
    <line class="newspaper" x1="4.36" y1="18.68" x2="15.82" y2="18.68" />
  </svg>
</template>